/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Has_LabelInputs */

const en_filter_has_label = /** @type {(inputs: Filter_Has_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`labels`)
};

const de_filter_has_label = /** @type {(inputs: Filter_Has_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels`)
};

/**
* | output |
* | --- |
* | "labels" |
*
* @param {Filter_Has_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_has_label = /** @type {((inputs?: Filter_Has_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Has_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_has_label(inputs)
	return en_filter_has_label(inputs)
});